import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../app/api";
import useUrlQuery from "../hooks/useUrlQuery";

/* ---------------- STATUS QUERY ---------------- */

export const useStatusQuery = () => {
  const { getUrlQuery } = useUrlQuery();
  const proposal_id = getUrlQuery("proposal_id");

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["status", proposal_id],

    queryFn: () =>
      api.post("/GetBikePolicyDetails", {
        PROPOSAL_ID: proposal_id,
      }),

    enabled: !!proposal_id,
  });

  return {
    status: data?.data?.POLICY_DATA?.[0],
    isLoading,
    isSuccess,
  };
};

/* ---------------- GET DOCUMENT ---------------- */

export const useGetDocument = () => {
  const { isSuccess, status } = useStatusQuery();
  const { getUrlQuery } = useUrlQuery();
  const proposal_id = getUrlQuery("proposal_id");

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["document", proposal_id],

    queryFn: () =>
      api.post("/BikeGenerateDocument", {
        PROPOSAL_ID: proposal_id,
      }),

    enabled: isSuccess && !status?.POLICY_DOC,
  });

  return {
    data: data?.data?.response?.POLICY_DOC,
    isLoading,
    refetch,
  };
};

/* ---------------- RETRY DOCUMENT ---------------- */

export const useRetryDocument = () => {
  return useMutation({
    mutationFn: (payload) =>
      api.post("/BikePolicyStatusResponse", {
        POLICY_NUMBER: payload?.POLICY_NUMBER,
      }),

    // onSuccess: (res) => {
    //   console.log(res, "res");
    // },
  });
};
